// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsedActivityPreview-cls1___bdd8653843bf3f723d6{/*!*/}.CollapsedActivityPreview-cls2__e3fcf987d75563d0f7ef{display:flex;flex-direction:column}@media(min-width: 768px){.CollapsedActivityPreview-cls2__e3fcf987d75563d0f7ef{flex-direction:row;grid-gap:16px;gap:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsedActivityPreview-cls1___bdd8653843bf3f723d6",
	"cls2": "CollapsedActivityPreview-cls2__e3fcf987d75563d0f7ef CollapsedActivityPreview-cls1___bdd8653843bf3f723d6"
};
export default ___CSS_LOADER_EXPORT___;
